import React from "react";
import styles from "./ShareMenu.module.css";
import {
	fw400,
	primaryTextColor,
	secondaryTextColor,
	titleS,
} from "../../../Global.module.css";
import { copyToClipboard } from "../../../helpers/copyToClipboard";
import CopyIcon from "../../../assets/notepad.svg";

export const showAccessCode = (state, shareOptions, changeAccessCode) => {
	if (state.shareOption === shareOptions.PROTECTED)
		return (
			<div className={styles.clipboardBlock}>
				<p className={`${secondaryTextColor} ${titleS} ${fw400} `}>
					Access Code
				</p>
				<div className={styles.clipboard}>
					<input
						className={`${primaryTextColor} ${titleS} ${fw400} ${styles.inputBox}`}
						value={state.accessCode}
						onChange={changeAccessCode}
					/>
					<button
						className={styles.subActionBtn}
						onClick={() => copyToClipboard(state.accessCode)}
					>
						<img src={CopyIcon} alt="Copy Icon" />
						<p className={`${fw400} ${titleS}`}>Copy</p>
					</button>
				</div>
			</div>
		);
	return null;
};
